'use client';
import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import React from 'react';

interface AccordionItem {
  id: string
  title: string
  content: string | React.ReactNode
}

interface AccordionProps {
  items: AccordionItem[]
  allowMultiple?: boolean
}

export default function Accordion({ items, allowMultiple = false }: AccordionProps) {
  const [openItems, setOpenItems] = useState<string[]>([])
  
  const toggleItem = (id: string) => {
    if (allowMultiple) {
      setOpenItems(prev => 
        prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
      )
    } else {
      setOpenItems(prev => prev.includes(id) ? [] : [id])
    }
  }
  
  return (
    <div className="space-y-2">
      {items.map((item) => {
        const isOpen = openItems.includes(item.id)
        return (
          <div key={item.id} className="border border-border bg-surface-1">
            <button
              onClick={() => toggleItem(item.id)}
              className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors"
            >
              <span className="text-h5 text-white">{item.title}</span>
              <Icon 
                name="ChevronDownIcon" 
                size={20} 
                className={`transition-transform duration-base text-white ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>
            {isOpen && (
              <div className="px-6 pb-6 text-body-sm text-gray-300 border-t border-border pt-6">
                {item.content}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}